import withData from '@bd/bdcore-data';
import Page from './Page';

export default function PageLoader(page) {
  return withData({ page })(Page);
}



// WEBPACK FOOTER //
// ./src/components/PageLoader/index.js